import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createPosTerminal, saveRestaurant, editEntityField, confirm } from '../../../actions';
import { Form, Button, Input, Dropdown, Divider, Checkbox } from 'semantic-ui-react';
import i18next from 'i18next';
import onlinePaymentProviders from '../../../consts/OnlinePaymentProviders';
import dealers from '../../../consts/Dealers';
import cibusCompanies from '../../../consts/CibusCompanies.json';
import TipSets from '../../../consts/TipSets.json';
import { posConfigFactory } from '../../common/DataGrid/filters/helper';

const paymentProviders = ['tenbis', 'cibus', 'goodi', 'multipass'];

const loyaltyAuthConfigs = {
    como: ['apiToken', 'branchId', 'joinCode', 'multifactorAuth'],
    valuecard: ['apiToken', 'branchId', 'branchPassword', 'multifactorAuth'],
    verifone: ['apiUrl', 'groupCode', 'chainCode', 'branchUsername', 'branchPassword', 'creditsCode'],
    verifone_gi: ['apiUrl', 'groupCode', 'chainCode', 'branchUsername', 'branchPassword', 'creditsCode'],
    dreamcard: ['apiUrl', 'groupCode', 'chainCode', 'branchUsername', 'branchPassword', 'creditsCode'],
    pizzahut: ['branchId']
};

class RestaurantSettingsEditor extends Component {
    unlinkMenu = () => {
        this.props.confirm({
            title: i18next.t('unlinkMenu'),
            message: i18next.t('unlinkMenuMessage'),
            onConfirm: () => this.props.saveRestaurant({ id: this.props.entity.id, menuId: null })
        });
    }

    handleSubmit = (event) => {
        this.props.saveRestaurant(this.props.entity);
        event.preventDefault();
    }

    renderPosDetails = rest => {
        const { posSuppliers } = this.props;

        return (
            <Fragment>
                <Form.Field required>
                    <label>{i18next.t('posSupplier')}</label>
                    <Dropdown
                        placeholder={i18next.t('posSupplier')}
                        required
                        fluid
                        selection
                        options={posSuppliers.map((pos) => ({ value: pos.id, text: pos.name })).sort((pos1, pos2) => pos1.text > pos2.text ? 1 : -1)}
                        value={rest.posConfig ? rest.posConfig.posId : null}
                        onChange={(e, { value }) => {
                            const posConfig = posConfigFactory(value, posSuppliers);

                            this.props.editEntityField('posConfig', posConfig);
                            this.props.editEntityField('posSupplierId', value);
                        }}
                    />
                </Form.Field>
                {rest.posConfig && this.renderPosConfig(rest)}
            </Fragment>
        );
    }

    renderPosConfig = rest => {
        const { posConfig } = rest;

        if (posConfig && posConfig.posId) {
            const { config } = this.props.posSuppliers.find(ps => ps.id == posConfig.posId);

            return config.map(({ field, type }) => {
                return (
                    <Form.Field key={field}>
                        {type === 'bool'
                            ? <Checkbox
                                label={field}
                                checked={posConfig[field]}
                                onChange={(e, { checked }) => this.props.editEntityField(`posConfig.${field}`, checked)}
                            />
                            : <Input
                                label={field}
                                placeholder={field}
                                value={posConfig[field] || ''}
                                onChange={({ target }) => {
                                    this.props.editEntityField(`posConfig.${field}`, target.value);
                                    if (field === 'posBranchId') {
                                        this.props.editEntityField(`posBranchId`, target.value);
                                    }
                                }}
                            />
                        }
                    </Form.Field>
                );
            });
        }

        return null;
    }

    renderExternalLoyalty = rest => {
        if (!rest.externalLoyaltyProgram || !rest.externalLoyaltyProgram.auth) return null;

        const { auth, provider } = rest.externalLoyaltyProgram;

        const authConfig = loyaltyAuthConfigs[provider];

        return (
            <Fragment>
                {authConfig.includes('apiUrl') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'API Url'}
                            value={auth.apiUrl || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, apiUrl: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('apiToken') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'API Token'}
                            value={auth.apiToken || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, apiToken: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('chainCode') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'Chain Code'}
                            value={auth.chainCode || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, chainCode: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('groupCode') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'Group Code'}
                            value={auth.groupCode || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, groupCode: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('branchId') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'Branch ID'}
                            value={auth.branchId || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, branchId: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('branchUsername') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'Username'}
                            value={auth.branchUsername || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, branchUsername: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('branchPassword') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'Password'}
                            value={auth.branchPassword || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, branchPassword: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('joinCode') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'Join Code'}
                            value={auth.joinCode || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, joinCode: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('creditsCode') &&
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'Credits Code'}
                            value={auth.creditsCode || ''}
                            onChange={({ target }) => this.props.editEntityField('externalLoyaltyProgram.auth', { ...auth, creditsCode: target.value })}
                        />
                    </Form.Field>
                }
                {authConfig.includes('multifactorAuth') &&
                    <Form.Group>
                        <Form.Field>
                            <Form.Checkbox
                                label={i18next.t('multifactorAuth')}
                                checked={auth.forceMemberAuthentication}
                                onChange={(e, { checked }) => {
                                    this.props.editEntityField('externalLoyaltyProgram.auth',
                                        { ...auth, forceMemberAuthentication: checked, multifactorAuthMethod: checked ? 'Sms' : '' });
                                }}
                            />
                        </Form.Field>
                    </Form.Group>
                }
            </Fragment>
        );
    }

    renderOnlinePaymentDetails = (onlinePaymentConfig) => {
        if (!onlinePaymentConfig) return null;

        return (
            <Fragment>
                <Form.Field>
                    <label>{i18next.t('paymentInfo')}</label>
                    <Dropdown
                        placeholder={"Online Payment Provider"}
                        required
                        fluid
                        selection
                        options={onlinePaymentProviders.map(provider => ({ value: provider, text: String(provider).toUpperCase() }))}
                        value={onlinePaymentConfig.provider || ''}
                        onChange={(e, { value }) => this.props.editEntityField('onlinePaymentConfig.provider', value)}
                    />
                </Form.Field>
                {onlinePaymentConfig.provider === 'creditguard' &&
                    <Form.Field>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <Dropdown
                                    placeholder={dealers.join('/')}
                                    required
                                    fluid
                                    selection
                                    options={dealers.map((dealer) => ({ value: dealer, text: dealer }))}
                                    value={onlinePaymentConfig.dealer || ''}
                                    onChange={(e, { value }) => {
                                        this.props.editEntityField('dealer', value);
                                        this.props.editEntityField('onlinePaymentConfig.dealer', value);
                                    }}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Input
                                    fluid
                                    required
                                    placeholder={'xxxxxx'}
                                    value={onlinePaymentConfig.dealerNumber || ''}
                                    onChange={({ target }) => {
                                        this.props.editEntityField('dealerNumber', target.value);
                                        this.props.editEntityField('onlinePaymentConfig.dealerNumber', target.value);
                                    }}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form.Field>
                }
                {onlinePaymentConfig.provider === 'paypal' &&
                    <Form.Field>
                        <Input
                            fluid
                            required
                            placeholder={'Paypal merchant id'}
                            value={onlinePaymentConfig.merchantId || ''}
                            onChange={({ target }) => this.props.editEntityField('onlinePaymentConfig.merchantId', target.value)}
                        />
                    </Form.Field>
                }
            </Fragment>
        );
    }

    render() {
        const { entity } = this.props;
        const rest = entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                {this.renderPosDetails(rest)}

                {this.renderOnlinePaymentDetails(rest.onlinePaymentConfig)}

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('onlineTippingSupport')}
                        checked={!!rest.tippingOptions}
                        onChange={(e, { checked }) => this.props.editEntityField('tippingOptions', checked ? { defaultValues: TipSets[0] } : null)}
                    />
                </Form.Field>

                {rest.tippingOptions &&
                    <Form.Field>
                        <Dropdown
                            fluid
                            selection
                            options={TipSets.map(set => ({ value: set.join('|'), text: set.join(' | ') }))}
                            value={rest.tippingOptions.defaultValues.join('|')}
                            onChange={(e, { value }) => this.props.editEntityField('tippingOptions.defaultValues', value.split('|'))}
                        />
                    </Form.Field>
                }

                {rest.taxesSetup &&
                    <Form.Field>
                        <label>{i18next.t('taxes.surcharge')}</label>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <Dropdown
                                    fluid
                                    selection
                                    options={['', 'surchargeRate', 'surchargePrice'].map((surchargeType) => ({ value: surchargeType, text: surchargeType ? i18next.t(`taxes.${surchargeType}`) : i18next.t('taxes.noSurcharge') }))}
                                    value={Object.keys(rest.taxesSetup).find(key => key.startsWith('surcharge') && rest.taxesSetup[key] != null) || ''}
                                    onChange={(e, { value }) => {
                                        const taxesSetup = { ...rest.taxesSetup, surchargeRate: undefined, surchargePrice: undefined };
                                        if (value) taxesSetup[value] = 0;
                                        this.props.editEntityField('taxesSetup', taxesSetup);
                                    }}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Input
                                    fluid
                                    disabled={rest.taxesSetup.surchargeRate == null && rest.taxesSetup.surchargePrice == null}
                                    max="100"
                                    type="number"
                                    step="any"
                                    value={rest.taxesSetup.surchargeRate != null ? Number((rest.taxesSetup.surchargeRate * 100).toFixed(3)) : (rest.taxesSetup.surchargePrice || '')}
                                    onChange={({ target }) => {
                                        if (rest.taxesSetup.surchargeRate != null) this.props.editEntityField('taxesSetup.surchargeRate', Number((target.value / 100).toFixed(5)));
                                        if (rest.taxesSetup.surchargePrice != null) this.props.editEntityField('taxesSetup.surchargePrice', target.value / 1);
                                    }}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form.Field>
                }

                <Form.Field>
                    <label>{i18next.t('installmentsFormula')}</label>
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'*100 (For every 100 allow +1 installment)'}
                            value={rest.installmentsFormula || ''}
                            onChange={({ target }) => this.props.editEntityField('installmentsFormula', target.value)}
                            style={{ direction: 'ltr' }}
                        />
                    </Form.Field>
                </Form.Field>

                {!rest.supportQuickPayment ? null :
                    <Form.Field>
                        <Form.Checkbox
                            label={i18next.t('quickPayToPos')}
                            checked={rest.sendQuickPayToPos}
                            onChange={(e, { checked }) => this.props.editEntityField('sendQuickPayToPos', checked)}
                        />
                    </Form.Field>
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('kiosks.tenbisConfig')}
                        checked={!!rest.tenbisConfig}
                        onChange={(e, { checked }) => this.props.editEntityField('tenbisConfig', checked ? {} : null)}
                    />
                </Form.Field>

                {rest.tenbisConfig &&
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'Restaurant key'}
                                required
                                value={rest.tenbisConfig.restaurantKey || ''}
                                onChange={({ target }) => this.props.editEntityField('tenbisConfig.restaurantKey', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'Username'}
                                required
                                value={rest.tenbisConfig.username || ''}
                                onChange={({ target }) => this.props.editEntityField('tenbisConfig.username', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'Password'}
                                required
                                value={rest.tenbisConfig.password || ''}
                                onChange={({ target }) => this.props.editEntityField('tenbisConfig.password', target.value)}
                            />
                        </Form.Field>
                    </Form.Group>
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('kiosks.cibusConfig')}
                        checked={!!rest.cibusConfig}
                        onChange={(e, { checked }) => this.props.editEntityField('cibusConfig', checked ? {} : null)}
                    />
                </Form.Field>

                {rest.cibusConfig &&
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'Restaurant key'}
                                required
                                value={rest.cibusConfig.restaurantKey || ''}
                                onChange={({ target }) => this.props.editEntityField('cibusConfig.restaurantKey', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'Terminal'}
                                required
                                value={rest.cibusConfig.terminal || ''}
                                onChange={({ target }) => this.props.editEntityField('cibusConfig.terminal', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Dropdown
                                fluid
                                selection
                                options={[{ value: 0, text: 'none' }, { value: 'companiesBlacklist', text: 'Blacklist' }, { value: 'companiesWhitelist', text: 'Whitelist' }]}
                                value={Object.keys(rest.cibusConfig).find(key => key.startsWith('companies') && rest.cibusConfig[key]) || 0}
                                onChange={(e, { value }) => {
                                    const { companiesBlacklist, companiesWhitelist, ...cibusConfig } = rest.cibusConfig;

                                    if (value) {
                                        this.props.editEntityField(`cibusConfig`, { ...cibusConfig, [value]: [] });
                                    } else {
                                        this.props.editEntityField(`cibusConfig`, { ...cibusConfig });
                                    }
                                }}
                            />
                        </Form.Field>
                    </Form.Group>
                }
                {rest.cibusConfig && rest.cibusConfig.companiesBlacklist &&
                    <Form.Field>
                        <Dropdown
                            fluid
                            selection
                            search
                            multiple
                            options={cibusCompanies.map(({ id, name }) => ({ value: String(id), text: `${id} - ${name}` }))}
                            value={rest.cibusConfig.companiesBlacklist}
                            onChange={(e, { value }) => this.props.editEntityField('cibusConfig.companiesBlacklist', value)}
                        />
                    </Form.Field>
                }
                {rest.cibusConfig && rest.cibusConfig.companiesWhitelist &&
                    <Form.Field>
                        <Dropdown
                            fluid
                            selection
                            search
                            multiple
                            options={cibusCompanies.map(({ id, name }) => ({ value: String(id), text: `${id} - ${name}` }))}
                            value={rest.cibusConfig.companiesWhitelist}
                            onChange={(e, { value }) => this.props.editEntityField('cibusConfig.companiesWhitelist', value)}
                        />
                    </Form.Field>
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('kiosks.goodiConfig')}
                        checked={!!rest.goodiConfig}
                        onChange={(e, { checked }) => this.props.editEntityField('goodiConfig', checked ? {} : null)}
                    />
                </Form.Field>

                {rest.goodiConfig &&
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'Restaurant key'}
                                required
                                value={rest.goodiConfig.restaurantKey || ''}
                                onChange={({ target }) => this.props.editEntityField('goodiConfig.restaurantKey', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'Terminal'}
                                required
                                value={rest.goodiConfig.terminal || ''}
                                onChange={({ target }) => this.props.editEntityField('goodiConfig.terminal', target.value)}
                            />
                        </Form.Field>
                    </Form.Group>
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('kiosks.multipassConfig')}
                        checked={!!rest.multipassConfig}
                        onChange={(e, { checked }) => this.props.editEntityField('multipassConfig', checked ? {} : null)}
                    />
                </Form.Field>

                {rest.multipassConfig &&
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={'POS ID'}
                                required
                                value={rest.multipassConfig.posId || ''}
                                onChange={({ target }) => this.props.editEntityField('multipassConfig.posId', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Checkbox
                                label={'Use Scanner'}
                                checked={!!rest.multipassConfig.useScanner}
                                onChange={(e, { checked }) => this.props.editEntityField('multipassConfig.useScanner', checked)}
                            />
                        </Form.Field>
                    </Form.Group>
                }

                <Form.Field>
                    <label>{i18next.t('kiosks.customerTypes')}</label>
                    <Dropdown
                        placeholder={i18next.t('kiosks.customerTypes')}
                        fluid
                        selection
                        multiple
                        options={['employee'].map(value => ({ value, text: i18next.t(`customerTypes.${value}`) }))}
                        value={Object.keys(rest.customersConfig || {})}
                        onChange={(e, { value }) => this.props.editEntityField('customersConfig', value.length ? { ...value.reduce((config, key) => ({ ...config, [key]: { validation: { type: 'byCode', data: '' } } }), {}), ...rest.customersConfig } : null)}
                    />
                </Form.Field>

                {rest.customersConfig && Object.keys(rest.customersConfig).map(key => {
                    const currentConfig = rest.customersConfig[key];

                    return (
                        <Fragment key={key}>
                            <Form.Field>
                                <Dropdown
                                    fluid
                                    selection
                                    options={['byPaymentMethod', 'byCode'].map(value => ({ value, text: value }))}
                                    value={currentConfig.validation.type}
                                    onChange={(e, { value }) => this.props.editEntityField(`customersConfig.${key}`, { ...currentConfig, validation: { type: value } })}
                                />
                            </Form.Field>
                            {currentConfig.validation.type === 'byCode' &&
                                <Form.Field>
                                    <Input
                                        fluid
                                        placeholder={'code'}
                                        value={currentConfig.validation.data || ''}
                                        onChange={({ target }) => this.props.editEntityField(`customersConfig.${key}`, { ...currentConfig, validation: { ...currentConfig.validation, data: target.value } })}
                                    />
                                </Form.Field>
                            }
                            {currentConfig.validation.type === 'byPaymentMethod' &&
                                <Form.Field>
                                    <Dropdown
                                        fluid
                                        selection
                                        search
                                        multiple
                                        options={paymentProviders.map(value => ({ value, text: value })).concat(cibusCompanies.map(({ id, name }) => ({ value: `cibus:${id}`, text: `${id} - ${name}` })))}
                                        value={currentConfig.validation.data}
                                        onChange={(e, { value }) => this.props.editEntityField(`customersConfig.${key}`, { ...currentConfig, validation: { ...currentConfig.validation, data: value } })}
                                    />
                                </Form.Field>
                            }
                            <Divider />
                        </Fragment>
                    );
                })}

                <Form.Field>
                    <label>{i18next.t('externalLoyaltyProgram')}</label>
                    <Dropdown
                        placeholder={i18next.t('externalLoyaltyProgram')}
                        fluid
                        selection
                        options={['', ...Object.keys(loyaltyAuthConfigs)].map(value => ({ value, text: value }))}
                        value={(rest.externalLoyaltyProgram || {}).provider || ''}
                        onChange={(e, { value }) => this.props.editEntityField('externalLoyaltyProgram', value ? { provider: value, auth: {} } : null)}
                    />
                </Form.Field>

                {this.renderExternalLoyalty(rest)}

                <Divider />

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('terminated')}
                        checked={rest.isTerminated}
                        onChange={(e, { checked }) => this.props.editEntityField('isTerminated', checked)}
                    />
                    <Form.Checkbox
                        label={i18next.t('suspended')}
                        checked={rest.isSuspended}
                        onChange={(e, { checked }) => this.props.editEntityField('isSuspended', checked)}
                    />
                </Form.Field>

                <Button primary type='submit' floated="right" disabled={!rest.posSupplierId || !rest.ownerId}>
                    {i18next.t('save')}
                </Button>

                <Button color="red" floated="left" type='button' onClick={this.unlinkMenu} >
                    {i18next.t('unlinkMenu')}
                </Button>
            </Form>
        );
    }
}

RestaurantSettingsEditor.propTypes = {
    saveRestaurant: PropTypes.func,
    editEntityField: PropTypes.func,
    createPosTerminal: PropTypes.func,
    entity: PropTypes.object,
    posSuppliers: PropTypes.array,
    posTerminals: PropTypes.array,

    extra: PropTypes.object
};

const mapStateToProps = (state) => {
    const { entity, type } = state.editor;
    const { posTerminals } = state.businessApp.config;
    const { posSuppliers } = state.meta;

    return { entity: type === 'restaurantConfig' ? entity : null, posTerminals, posSuppliers };
};

export default connect(mapStateToProps, {
    saveRestaurant,
    editEntityField,
    createPosTerminal,
    confirm,
})(RestaurantSettingsEditor);
